import type { Book, DownloadFormat } from '../../shared/types'
import { BookCover } from './BookCover'

export function BookCard({
  book,
  onDownload,
}: {
  book: Book
  onDownload: (book: Book, format: DownloadFormat) => void
}) {
  return (
    <article className="book-card">
      <BookCover book={book} />
      <div className="book-card-content">
        <span className="book-number">Obra {String(book.id).padStart(2, '0')}</span>
        <h2>{book.title}</h2>
        <p>{book.description}</p>
        <div className="download-actions" aria-label={`Downloads de ${book.title}`}>
          <button className="download-action" type="button" onClick={() => onDownload(book, 'pdf')}>
            <FileIcon format="PDF" />
            <span>PDF</span>
          </button>
          <button className="download-action" type="button" onClick={() => onDownload(book, 'epub')}>
            <FileIcon format="EPUB" />
            <span>EPUB</span>
          </button>
        </div>
      </div>
    </article>
  )
}

function FileIcon({ format }: { format: 'PDF' | 'EPUB' }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M6.5 3.5h7l4 4v13h-11z" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M13.5 3.5v4h4" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <text x="12" y="17" textAnchor="middle" fontSize="5" fontWeight="800">{format}</text>
    </svg>
  )
}
